var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIconSmallBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85232 0.147684C6.04923 0.344595 6.04923 0.663851 5.85232 0.860763L3.71308 3L5.85232 5.13924C6.04923 5.33615 6.04923 5.65541 5.85232 5.85232C5.65541 6.04923 5.33615 6.04923 5.13924 5.85232L3 3.71308L0.860763 5.85232C0.663851 6.04923 0.344595 6.04923 0.147684 5.85232C-0.049228 5.65541 -0.0492277 5.33615 0.147684 5.13924L2.28692 3L0.147684 0.860763C-0.0492278 0.663851 -0.0492277 0.344595 0.147684 0.147684C0.344595 -0.0492279 0.663851 -0.0492278 0.860763 0.147684L3 2.28692L5.13924 0.147684C5.33615 -0.0492278 5.6554 -0.0492279 5.85232 0.147684Z",
    fill: "#333541"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIconSmallBlack);
export default __webpack_public_path__ + "static/media/x-icon-small-black.9b3fc3e6dfb90fa7a8edac815edc3861.svg";
export { ForwardRef as ReactComponent };